import { assertUnreachable } from '@dreryk/react-common';

import { ReceptionServiceFormBean } from '../../../ReceptionServiceForm';

export const getDefaultValue = (bean: ReceptionServiceFormBean): number => {
   if (bean.freeChecked) {
      return assertUnreachable(undefined);
   }

   if (bean.priceRange) {
      return bean.priceRange.min;
   }

   if (bean.price) {
      return bean.price;
   }

   return 1;
};
